import { IViolationFixGrade } from 'APIPackage/CatalogsModule/interfaces/IViolationFixGrade';
import { IViolationFixGradeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IViolationFixGradeSelectOption';

export function createViolationFixGradeSelectOption(
  violationFixGrade: IViolationFixGrade,
): IViolationFixGradeSelectOption {
  return {
    ...violationFixGrade,
    label: violationFixGrade.title,
    value: violationFixGrade.code,
  };
}
